module.exports = {"id":"212478","name":"Gyasi Zardes","rating":"71","photo":"./data/images/photos/4/212478.png","club":{"name":"Columbus Crew","logo":"./data/images/clubs/ColumbusCrew.png"},"positions":["BU","MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GyasiZardes0.json
// module id = 1678
// module chunks = 0